import axios from 'axios';

export const accountBlockLite = id =>
  axios.post(`/lite/social-network-lite/${id}/block `);

export const allAccountsBlockLite = id =>
  axios.post(`/lite/social-network-lite/block-all/${id}`);
